




import {Component, Ref, Vue} from 'vue-property-decorator'
import Tariff from '../Tarification/Tariff.vue';
import {TarificationTypes, TarificationTransports} from "@/store/tarification/types";

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {Tariff}})
export default class CustomPartnerTariff extends Vue {

  @Ref('tariff') tariff!: Tariff;

  private partnerType: TarificationTypes = TarificationTypes.PARTNER;
  private tarificationTransport: TarificationTransports = TarificationTransports.CUSTOM;

  beforeRouteLeave(to: any, from: any, next: any) {
    this.tariff.beforeLeave(to, from, next);
  }
}
